import useAccess from '@/composables/access/access';
import { computed } from 'vue';
import { experimentFlag } from 'shared/experiments.json';
import { parentAlignmentType, viewType } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';

export default function useParentAlignment(savedView) {
  const { t } = useI18n();
  const { accountHasFeature } = useAccess();

  const parentAlignmentOptions = [
    { text: t('parentAlignment.hidden'), value: parentAlignmentType.hidden },
    { text: t('parentAlignment.direct'), value: parentAlignmentType.direct },
    ...(accountHasFeature([experimentFlag.fullTreeParentAlignment])
      ? [{ text: t('parentAlignment.full'), value: parentAlignmentType.full }]
      : []
    ),
  ];

  const defaultParentAlignment = (type) => {
    if ([viewType.cascade].includes(type)) {
      return parentAlignmentType.direct;
    }
    return parentAlignmentType.hidden;
  };

  const parentAlignmentLabel = computed(() => t('parentAlignment.label'));

  const parentAlignment = computed(() => {
    if (![viewType.cascade].includes(savedView.value.viewType)) {
      return parentAlignmentType.hidden;
    }

    if (savedView.value.params?.parentAlignment !== undefined) {
      return savedView.value.params.parentAlignment;
    }

    return defaultParentAlignment(savedView.value.viewType);
  });

  return { parentAlignmentOptions, defaultParentAlignment, parentAlignment, parentAlignmentLabel };
}
